import { FunctionComponent, memo, useEffect } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { ICountry } from "./ICountry";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import TextInputFieldC from "../../Components/TextInput/TextInputFieldC";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { addCountry } from "../../Redux/Slices/Country/AddCountrySlice";
import { EditCountry } from "../../Redux/Slices/Country/EditCountrySlice";
import Select from "../../Components/Select/AutoComplete";
import { AutocompleteOption } from "../../Components/Select/ISelectProps";
import { listState } from "../../Redux/Slices/ExterAPI/ListStateSlice";

interface CountryFormProps {
  formRef: React.RefObject<HTMLFormElement>;
  initialValues: ICountry;
  setInitialValues: React.Dispatch<React.SetStateAction<ICountry>>;
}

const CountryForm: FunctionComponent<CountryFormProps> = (props) => {
  const dispatch = useAppDispatch();

  const userSchema = z.object({
    id: z.number().optional(),
    // timezone: z
    //   .string({ message: "Please enter time zone" })
    //   .min(1, { message: "Please enter time zone" }),
    state: z.string({
      required_error: "Please select state",
      invalid_type_error: "Please select state",
    }),
    region: z.string({
      required_error: "Please select country",
      invalid_type_error: "Please select country",
    }),
    status: z.boolean({
      message: "Please select the status",
    }),
  });
  const methods = useForm<ICountry>({
    defaultValues: {
      ...props.initialValues,
      status: props.initialValues.id ? props.initialValues.status : true,
    },
    resolver: zodResolver(userSchema),
    mode: "onChange",
  });

  const { data: ListCountry } = useAppSelector(
    (state) => state.ListCountryListSlice
  );

  const { data: ListState } = useAppSelector((state) => state.ListStateSlice);

  const ListCountrys = Array.isArray(ListCountry?.data)
    ? ListCountry?.data.map((listQuestions) => ({
        label: listQuestions?.name!,
        value: listQuestions.name,
      }))
    : [];

  const ListStates = Array.isArray(ListState?.data)
    ? ListState?.data.map((listQuestions) => ({
        label: listQuestions?.name!,
        value: listQuestions.name,
      }))
    : [];

  const onSubmit: SubmitHandler<ICountry> = (val) => {
    if (val.id) {
      dispatch(EditCountry(val));
    } else {
      dispatch(addCountry(val));
    }
  };

  const QuestionTypeSatus = [
    {
      label: "Active",
      value: true,
    },

    {
      label: "Inactive",
      value: false,
    },
  ];
  useEffect(() => {
    return () => {
      props.setInitialValues({});
    };
  }, [dispatch, props]);

  useEffect(() => {
    if (methods.getValues("region")) {
      dispatch(listState({ country: methods.getValues("region") }));
    }
  }, [methods.getValues("region")]);
  return (
    <FormProvider {...methods}>
      <form
        ref={props.formRef}
        onSubmit={methods.handleSubmit(onSubmit)}
        className="form_content"
      >
        <Select
          name="region"
          label="Select  the country"
          options={ListCountrys ?? []}
          value={
            ListCountrys?.find(
              (list) => list.value === methods.getValues("region")
            ) ?? null
          }
          onChange={(_, value) => {
            const val = value as AutocompleteOption;
            methods.setValue("region", val?.value, {
              shouldValidate: true,
            });

            dispatch(listState({ country: val?.value }));
          }}
        />
        <Select
          name="state"
          label="Select  the state"
          options={ListStates ?? []}
          value={
            ListStates?.find(
              (list) => list.value === methods.getValues("state")
            ) ?? null
          }
          onChange={(_, value) => {
            const val = value as AutocompleteOption;
            methods.setValue("state", val?.value, {
              shouldValidate: true,
            });
          }}
        />
        {/* <TextInputFieldC name="timezone" label="Time Zone" type="text" /> */}
        <Select
          name="status"
          label="Select  the status"
          options={QuestionTypeSatus ?? []}
          value={
            QuestionTypeSatus?.find(
              (list) => list.value === methods.getValues("status")
            ) ?? null
          }
          onChange={(_, value) => {
            const val = value as AutocompleteOption;
            methods.setValue("state", val?.value, {
              shouldValidate: true,
            });
          }}
        />
      </form>
    </FormProvider>
  );
};

export default memo(CountryForm);
